import {
	useLoaderData,
	Await,
	LoaderFunctionArgs,
	ShouldRevalidateFunction,
} from "react-router"
import { Suspense } from "react"
import { Outlet } from "react-router"
import { redirect, useParams } from "../../../../../router"
import { Spinner } from "@sembark-travel/ui/base"
import { TSheetFolder } from "../../../../../DataDrive"
import {
	dataDriveXHR,
	getCacheKeyForFolderDetails,
	useFolderDetails,
} from "../../../../../DataDrive/store"
import { mutate } from "swr"
import { xhr } from "@sembark-travel/xhr"

function swrLoaderData<T = unknown>(
	cacheKey: string,
	fetcher: () => Promise<T>
): Promise<T | undefined> {
	return mutate(
		cacheKey,
		async function getLoaderData(details?: T) {
			if (details) {
				// mutate the cache
				fetcher().then((data) => mutate(cacheKey, data, { revalidate: false }))
				// return the existing data
				return details
			}
			return fetcher()
		},
		{ revalidate: false }
	)
}

export async function Loader({ params }: LoaderFunctionArgs) {
	if (!params.folderId) {
		return redirect("/data-drive")
	}
	const { folderId } = params
	const cacheKey = getCacheKeyForFolderDetails(folderId)
	return {
		folderDetails: swrLoaderData(cacheKey, async () =>
			dataDriveXHR(xhr).getFolderDetails(folderId)
		),
	}
}

export const ShouldRevalidate: ShouldRevalidateFunction = () => {
	return false
}

export default function FolderLayout() {
	const { folderId } = useParams("/data-drive/folders/:folderId")
	const { folderDetails, refreshFolderDetails } = useFolderDetails(folderId, {
		revalidateOnMount: false,
	})
	const loader = useLoaderData() as {
		folderDetails: Promise<TSheetFolder>
	}

	return (
		<Suspense fallback={<Spinner padding="4" alignCenter />}>
			<Await resolve={loader.folderDetails}>
				{folderDetails ? (
					<Outlet context={{ folderDetails, refreshFolderDetails }} />
				) : (
					<Spinner padding="4" alignCenter />
				)}
			</Await>
		</Suspense>
	)
}
